import { useState } from "react";
import { useAuthContext } from "./useAuthContext";
import { api, apiError, AUTH_STORAGE_KEY } from "../functions/Api";

export const useLogin = () => {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(null);
  const { dispatch } = useAuthContext();

  const login = async (email, password) => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await api.post("/api/users/login", {
        email,
        password,
        role: ["cloud_admin", "super_admin"],
      });

      if (response.status === 200) {
        // save the user to local storage
        localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(response.data));

        // update the auth context
        dispatch({ type: "LOGIN", payload: response.data });

        // update loading state
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      setError(apiError(error, "Login failed. Please try again."));
    }
  };

  return { login, isLoading, error, setError };
};
